module.exports = __webpack_public_path__ + "static/media/RefreshGreen.be459374.svg";